angular.module('forms').directive('apTimeFrame',
    ['$q', 'ListService', 'FormsService', 'FormsId',
        function ($q, ListService, FormsService, FormsId) {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: '/forms/views/directives/apTimeFrame.html',
                scope: {
                    // Use '@' for one way binding.  String value is returned.
                    // Use '=' for two way binding.  An object is returned.
                    // Use '&' for a method.
                    timeFrameId: '=timeFrameId',
                    timeFrameAnswer: '=timeFrameAnswer',
                    timeFrameSelectedCallback: '&timeFrameSelectedCallback',
                    disabled: '=?'
                },
                // use link - use jquery to get a reference to the parent form tag.  then, save reference to $scope.
                // link 4th param $error
                require: '^form',
                link: function(scope, element, attrs, formCtrl) {
                    scope.formRef = formCtrl;
                },
                controller: function($scope) {
                    $scope.tfInputCtrlId  = 'tfInput_'  + $scope.timeFrameId;
                    $scope.calInputCtrlId = 'calInput_' + $scope.timeFrameId;
                    $scope.tfSelCtrlId    = 'tfSel_'    + $scope.timeFrameId;

                    if ($scope.timeFrameAnswer.OnsetTimeFrameId === FormsId.TimeFrameId.Clear) {
                        $scope.timeFrameAnswer.OnsetTimeFrameId = '';
                    }
                    if ($scope.timeFrameAnswer.OnsetTimeFrameValue !== '') {
                        $scope.timeFrameAnswer.OnsetTimeFrameValue = parseInt($scope.timeFrameAnswer.OnsetTimeFrameValue);
                    }

                    $scope.timeFrameInputIsVisible = FormsService.timeFrameInputIsVisible($scope.timeFrameAnswer.OnsetTimeFrameId);
                    $scope.calendarInputIsVisible  = FormsService.calendarInputIsVisible($scope.timeFrameAnswer.OnsetTimeFrameId);

                    $scope.datePickerModel = {
                        showDatePicker: false
                    };

                    $scope.minDate = moment().subtract(100, 'year');
                    $scope.maxDate = moment();


                    function loadView() {
                        var timeFramesPromise = ListService.getList('timeframes', $scope, 'timeFrameTypes');

                        $q.all([timeFramesPromise]).then(function () {
                            _.remove($scope.timeFrameTypes, {Name: '_'});
                            _.remove($scope.timeFrameTypes, {Name: 'Clear'});

                            var timeFrameEntryClear = {
                                TimeFrameId : FormsId.TimeFrameId.Clear,
                                Name: '--- Clear Selection ---',
                                Notes: '',
                                DefaultValue: '',
                                UseBirthDate: false,
                                AddToDate: false,
                                TimespanUnitType: 0,
                                TimespanUnitTypeName: '',
                                DisplayOrder: -1
                            };
                            $scope.timeFrameTypes.unshift(timeFrameEntryClear);
                        });
                    }
                    loadView();


                    $scope.datePickerChanged = function datePickerChanged() {
                        $scope.datePickerModel.showDatePicker = false;
                    };


                    $scope.timeFrameTypeChanged = function timeFrameTypeChanged() {
                        if ($scope.timeFrameAnswer.OnsetTimeFrameId.toUpperCase() === FormsId.TimeFrameId.Clear) {
                            // --- Clear Selection ---
                            $scope.timeFrameAnswer.OnsetTimeFrameId = '';
                            $scope.timeFrameAnswer.OnsetTimeFrameValue = '';
                            $scope.timeFrameAnswer.OnsetTimeFrameDate = '';
                            $scope.timeFrameAnswer.OnsetTimeFrameAnswer = '';
                            $scope.timeFrameInputIsVisible = false;
                            $scope.calendarInputIsVisible = false;
                            $scope.datePickerModel.showDatePicker = false;

                            $scope.timeFrameSelectedCallback({
                                timeFrameId: $scope.timeFrameId,
                                onsetTimeFrameId: $scope.timeFrameAnswer.OnsetTimeFrameId
                            });

                            return;
                        }

                        $scope.timeFrameAnswer.OnsetTimeFrameAnswer = '';
                        var timeFrameItem = _.find($scope.timeFrameTypes, {TimeFrameId: $scope.timeFrameAnswer.OnsetTimeFrameId});
                        if (timeFrameItem) {
                            $scope.timeFrameAnswer.OnsetTimeFrameAnswer = timeFrameItem.Name;
                        }

                        if ($scope.timeFrameAnswer.OnsetTimeFrameId.toUpperCase() === FormsId.TimeFrameId.Calendar) {
                            $scope.timeFrameAnswer.OnsetTimeFrameValue = '';
                            $scope.timeFrameAnswer.OnsetTimeFrameDate = '';
                            $scope.timeFrameInputIsVisible = false;
                            $scope.calendarInputIsVisible = true;
                            $scope.datePickerModel.showDatePicker = true;

                            $scope.timeFrameSelectedCallback({
                                timeFrameId: $scope.timeFrameId,
                                onsetTimeFrameId: $scope.timeFrameAnswer.OnsetTimeFrameId
                            });

                            return;
                        }

                        $scope.calendarInputIsVisible = false;
                        $scope.datePickerModel.showDatePicker = false;

                        var isTimeFrameInputVisible = true;

                        if ($scope.timeFrameAnswer.OnsetTimeFrameId.toUpperCase() === FormsId.TimeFrameId.DaysAgo) {
                            isTimeFrameInputVisible = true;
                        }
                        else if ($scope.timeFrameAnswer.OnsetTimeFrameId.toUpperCase() === FormsId.TimeFrameId.WeeksAgo) {
                            isTimeFrameInputVisible = true;
                        }
                        else if ($scope.timeFrameAnswer.OnsetTimeFrameId.toUpperCase() === FormsId.TimeFrameId.MonthsAgo) {
                            isTimeFrameInputVisible = true;
                        }
                        else if ($scope.timeFrameAnswer.OnsetTimeFrameId.toUpperCase() === FormsId.TimeFrameId.YearsAgo) {
                            isTimeFrameInputVisible = true;
                        }
                        else if ($scope.timeFrameAnswer.OnsetTimeFrameId.toUpperCase() === FormsId.TimeFrameId.Childhood) {
                            isTimeFrameInputVisible = false;
                        }
                        else if ($scope.timeFrameAnswer.OnsetTimeFrameId.toUpperCase() === FormsId.TimeFrameId.Teenager) {
                            isTimeFrameInputVisible = false;
                        }
                        else if ($scope.timeFrameAnswer.OnsetTimeFrameId.toUpperCase() === FormsId.TimeFrameId.Birth) {
                            isTimeFrameInputVisible = false;
                        }

                        $scope.timeFrameAnswer.OnsetTimeFrameValue = '';
                        $scope.timeFrameAnswer.OnsetTimeFrameDate = '';
                        $scope.timeFrameInputIsVisible = isTimeFrameInputVisible;

                        $scope.timeFrameSelectedCallback({
                            timeFrameId: $scope.timeFrameId,
                            onsetTimeFrameId: $scope.timeFrameAnswer.OnsetTimeFrameId
                        });
                    };

                }
            };
        }
    ]
);